import React from 'react'

import cx from 'classnames'
import { useTranslations } from 'next-intl'

import { LinkButton } from '../../../components/buttons/Button'
import { useGameImages } from '../../../components/games/images'
import { HeroContent } from './HeroContent'

import HeroImageMobile from 'assets/images/hero/clashroyale-mobile.png'
import HeroImage from 'assets/images/hero/clashroyale.png'

import styles from './Hero.module.scss'

const smoothScroll = (href: string) => (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
  if (event.metaKey) {
    return
  }

  event.preventDefault()
  const element = document.getElementById(href.replace('#', ''))
  element?.scrollIntoView({ behavior: 'smooth' })
}

export const CRHero = () => {
  const t = useTranslations()
  const crImages = useGameImages('clashroyale')

  const mobileDescription = (
    <>
      {t('lan_hero_card5_body')}
      &nbsp;
      <a href="#clashroyale" onClick={smoothScroll('#clashroyale')}>
        {t('lan_hero_button5')}
      </a>
    </>
  )
  return (
    <>
      <div className={cx(styles.Hero, styles.Mobile)}>
        <HeroContent
          image={HeroImageMobile}
          imagePriority
          imagePosition="95% 10%"
          title={t('lan_hero_card5_title')}
          description={mobileDescription}
          gameLogo={crImages.gameImage('logo')}
        ></HeroContent>
      </div>
      <div className={cx(styles.Hero, styles.Desktop)}>
        <HeroContent
          image={HeroImage}
          imagePriority
          imagePosition="95% 10%"
          title={t('lan_hero_card5_title')}
          description={t('lan_hero_card5_body')}
          gameLogo={crImages.gameImage('logo')}
        >
          <LinkButton
            additionalClasses={styles.OverlayAction}
            href="#clashroyale"
            onClick={smoothScroll('#clashroyale')}
            type="Secondary"
            content={t('lan_hero_button5')}
          />
        </HeroContent>
      </div>
    </>
  )
}
